import * as types from '../../../../lib/actionTypes.es6'

export function getOmkGroupsRequest(payload) {
  return {
    type: types.GET_OMK_GROUPS_REQUEST,
    payload: payload || {}
  }
}

export function getOmkGroupsSuccess(payload) {
  return {
    type: types.GET_OMK_GROUPS_SUCCESS,
    payload
  }
}

export function getOmkGroupsFailure(error) {
  return {
    type: types.GET_OMK_GROUPS_FAILURE,
    payload: error
  }
}

export function getOmkGroupRequest(guid) {
  return {
    type: types.GET_OMK_GROUP_REQUEST,
    payload: guid
  }
}

export function getOmkGroupSuccess(payload) {
  return {
    type: types.GET_OMK_GROUP_SUCCESS,
    payload
  }
}

export function getOmkGroupFailure(error) {
  return {
    type: types.GET_OMK_GROUP_FAILURE,
    payload: error
  }
}

export function approveOmkGroupRequest(guid) {
  return {
    type: types.APPROVE_OMK_GROUP_REQUEST,
    payload: guid
  }
}

export function approveOmkGroupSuccess(payload) {
  return {
    type: types.APPROVE_OMK_GROUP_SUCCESS,
    payload
  }
}

export function approveOmkGroupFailure(error) {
  return {
    type: types.APPROVE_OMK_GROUP_FAILURE,
    payload: error
  }
}

export function approveOmkGroupReset() {
  return { type: types.APPROVE_OMK_GROUP_RESET }
}

export function setOmkGroupVerificationRequest(payload) {
  return {
    type: types.SET_OMK_GROUP_VERIFICATION_REQUEST,
    payload
  }
}

export function setOmkGroupVerificationSuccess(payload) {
  return {
    type: types.SET_OMK_GROUP_VERIFICATION_SUCCESS,
    payload
  }
}

export function setOmkGroupVerificationFailure(error) {
  return {
    type: types.SET_OMK_GROUP_VERIFICATION_FAILURE,
    payload: error
  }
}

export function setOmkGroupVerificationReset() {
  return { type: types.SET_OMK_GROUP_VERIFICATION_RESET }
}

// payload: { guid, name, file }
export function uploadOmkGroupDocumentRequest(payload) {
  return {
    type: types.UPLOAD_OMK_GROUP_DOCUMENT_REQUEST,
    payload
  }
}

export function uploadOmkGroupDocumentSuccess(payload) {
  return {
    type: types.UPLOAD_OMK_GROUP_DOCUMENT_SUCCESS,
    payload
  }
}

export function uploadOmkGroupDocumentFailure(error) {
  return {
    type: types.UPLOAD_OMK_GROUP_DOCUMENT_FAILURE,
    payload: error
  }
}

export function uploadOmkGroupDocumentReset() {
  return { type: types.UPLOAD_OMK_GROUP_DOCUMENT_RESET }
}

// payload: { guid, docGuid }
export function deleteOmkGroupDocumentRequest(payload) {
  return {
    type: types.DELETE_OMK_GROUP_DOCUMENT_REQUEST,
    payload
  }
}

export function deleteOmkGroupDocumentSuccess(payload) {
  return {
    type: types.DELETE_OMK_GROUP_DOCUMENT_SUCCESS,
    payload
  }
}

export function deleteOmkGroupDocumentFailure(error) {
  return {
    type: types.DELETE_OMK_GROUP_DOCUMENT_FAILURE,
    payload: error
  }
}

export function deleteOmkGroupDocumentReset() {
  return { type: types.DELETE_OMK_GROUP_DOCUMENT_RESET }
}

// payload: { guid, page, size }
export function getOmkGroupPoliciesRequest(payload) {
  return {
    type: types.GET_OMK_GROUP_POLICIES_REQUEST,
    payload
  }
}

export function getOmkGroupPoliciesSuccess(payload) {
  return {
    type: types.GET_OMK_GROUP_POLICIES_SUCCESS,
    payload
  }
}

export function getOmkGroupPoliciesFailure(error) {
  return {
    type: types.GET_OMK_GROUP_POLICIES_FAILURE,
    payload: error
  }
}

// payload: { guid, policies, page, size } — `policies` are the full policy
// objects to approve, so the saga can decide per policy whether to record a
// maker-checker decision or write the status.
export function approveOmkGroupPoliciesRequest(payload) {
  return {
    type: types.APPROVE_OMK_GROUP_POLICIES_REQUEST,
    payload
  }
}

export function approveOmkGroupPoliciesStarted(total) {
  return {
    type: types.APPROVE_OMK_GROUP_POLICIES_STARTED,
    payload: total
  }
}

// payload: { label, guid, ok, error }
export function approveOmkGroupPolicyResult(payload) {
  return {
    type: types.APPROVE_OMK_GROUP_POLICY_RESULT,
    payload
  }
}

export function approveOmkGroupPoliciesSuccess() {
  return { type: types.APPROVE_OMK_GROUP_POLICIES_SUCCESS }
}

export function approveOmkGroupPoliciesFailure(error) {
  return {
    type: types.APPROVE_OMK_GROUP_POLICIES_FAILURE,
    payload: error
  }
}

export function approveOmkGroupPoliciesReset() {
  return { type: types.APPROVE_OMK_GROUP_POLICIES_RESET }
}

export function issueOmkGroupPoliciesStarted() {
  return { type: types.ISSUE_OMK_GROUP_POLICIES_STARTED }
}

// payload: { queued, skipped }
export function issueOmkGroupPoliciesQueued(payload) {
  return {
    type: types.ISSUE_OMK_GROUP_POLICIES_QUEUED,
    payload
  }
}

export function issueOmkGroupPoliciesRegistered() {
  return { type: types.ISSUE_OMK_GROUP_POLICIES_REGISTERED }
}

export function issueOmkGroupPoliciesPending() {
  return { type: types.ISSUE_OMK_GROUP_POLICIES_PENDING }
}

export function issueOmkGroupPoliciesFailure(error) {
  return {
    type: types.ISSUE_OMK_GROUP_POLICIES_FAILURE,
    payload: error
  }
}
